module.exports = __webpack_public_path__ + "img/img_Nodata@2x.049def78.png";